import Errors from './Errors';

export default class ErrorResponse {
  constructor() {
    this.errors = new Errors();
    this.statusCode = 0;
    this.message = '';
  }
}



// WEBPACK FOOTER //
// ./src/api/ErrorResponse.js